export const NODE_NAME = 'doc';
